import { useEffect } from "react";
import { useState } from "react";
import {
  getDeadline,
  getStatistics,
} from "../../../service/UserService/dashboardService";

export const useDashboardData = (userId) => {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(false);
  const [deadlines, setDeadlines] = useState();
  const [error, setError] = useState(null);

  const fetchStats = async () => {
    try {
      setLoading(true);

      const [statsData, deadlineData] = await Promise.all([
        getStatistics(userId),
        getDeadline(),
      ]);

      setStats(statsData.data);
      setDeadlines(deadlineData);
      setError(null);
    } catch (err) {
      console.error(err);
      setError(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!userId) return;
    fetchStats();
  }, []);

  return {
    stats,
    deadlines,
    loading,
    error,
  };
};
